export default __webpack_public_path__ + "static/media/premium-plan.68cc7525.svg";